//import * as lib from '../lib/lib'
import $ from 'jquery'

class Map {
  constructor(element) {
    if (!element) return

    this.element = element
    this.wrap = jQuery(element)

    this.iniElements()

    this.iniMap()

    console.log('map', this.map)
  }

  iniElements() {
    this.map = $('#map', this.wrap)
    this.data = window.locationData !== 'undefined' ? window.locationData : []

    console.log(this.data)
  }

  iniMap() {
    if (this.data != null) {
      var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        disableDefaultUI: true,
        zoomControl: true,

        styles: [
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#e2e5e9',
              },
            ],
          },
          {
            featureType: 'landscape.natural.landcover',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#f7ead2',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi.medical',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#e2e5e9',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#a3d691',
              },
            ],
          },
          {
            featureType: 'poi.sports_complex',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#a3d691',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels.text',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit.line',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#afd7fb',
              },
            ],
          },
        ],
        center: new google.maps.LatLng(
          this.data[0].latitude,
          this.data[0].longitude
        ),
      })

      //   var infowindow = new google.maps.InfoWindow();
      var marker, i

      const contentString =
        '<div><strong>Center Point</strong><br>Uluru (Ayers Rock), Australia</div>'

      // Create an info window object
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      })

      for (i = 0; i < this.data.length; i++) {
        marker = new google.maps.Marker({
          position: new google.maps.LatLng(
            this.data[i].latitude,
            this.data[i].longitude
          ),
          map: map,
          icon: '/imgs/icons/pin.svg',
        })

        const contentString =
          '<div class="e-infowindow"><span class ="e-infowindow__title">' +  
          `${this.data[i].tooltipData.title}` + '</span> <span class="e-infowindow__address">' + 
          `${this.data[i].tooltipData.address}` + '</span> <span class="e-infowindow__url"><a href="' + 
          `${this.data[i].tooltipData.url}`+ '" target="_blank">' + `${this.data[i].tooltipData.urlLabel}` + '</a></span> </div>'

        // Create an info window object
        const infowindow = new google.maps.InfoWindow({
          content: contentString,
        })

        infowindow.open(map, marker)

        // google.maps.event.addListener(marker, 'click', ( (marker, i)=> {
        //     console.log('for', this.data[i])

        //     return  () => {
        //         infowindow.setContent(`
        //         <div class="e-infoWindow">
        //             <span class ="e-infoWindow__title"> ${this.data[i].id} </span>

        //             </div>`
        //         );
        //         infowindow.open(map, marker);
        //     }
        // })(marker, i));
      }
    }
  }
}

export default Map
